import { Component } from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import {AsyncPipe} from "@angular/common";
import {ChooseYourGameComponent} from "../../../components/choose-your-game/choose-your-game.component";
import {ContainerComponent} from "@coreui/angular";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {CharityPayoutsComponent} from "../charity-payouts.component";

@Component({
  selector: 'app-cross-game-charity-payouts',
  standalone: true,
  imports: [
    AgGridAngular,
    AsyncPipe,
    ChooseYourGameComponent,
    ContainerComponent,
    CharityPayoutsComponent
  ],
  templateUrl: './cross-game-charity-payouts.component.html',
  styleUrl: './cross-game-charity-payouts.component.css'
})
export class CrossGameCharityPayoutsComponent  {

  protected game: IGameQueryResult | null = null;

  onGameChosen(chosenGameP: IGameQueryResult) {
    this.game = chosenGameP;
  }
}
